var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.userContext || _vm.userContext.classCode)?_c('unauthenticated-homepage',{staticClass:"main homepage"}):_c('authenticated-homepage'),_vm._v(" "),_c('password-modal',{attrs:{"confirm":"","mode":"teacher","modal-title":"Reset Password","modal-id":"modal-post-reset-password-change"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }